import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { JsonFileService } from '../../services/json-file.service';


export class LanguageService extends JsonFileService {
    constructor(protected http: Http) { super(http); }

    getFilePath(): string {
        return 'assets/data/languages.json';
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
